import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchDailyBrief } from "../../services/aiBriefService";

export default function AiDailyBrief() {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    fetchDailyBrief().then((data) => {
      if (cancelled) return;
      setBrief(data);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  // Sidebar preview: first 4 bullets, full brief lives at /permbledhja-e-dites
  const preview = brief?.bullets?.slice(0, 4) || [];
  const hasMore = (brief?.bullets?.length || 0) > 4 || !!brief?.prose;

  return (
    <div className="rounded-card bg-ai-bg p-5">
      <div className="mb-1.5 flex items-center gap-2">
        <span className="grid h-[22px] w-[22px] place-items-center rounded-md bg-ai text-[13px] text-white">
          ✦
        </span>
        <h3 className="font-head text-[17px] font-bold text-ink">
          Përmbledhja e ditës
        </h3>
      </div>
      <p className="mb-3.5 text-[11px] text-sub">
        Gjeneruar nga AI · përditësuar {brief?.updatedAt || "—"}
      </p>
      {loading ? (
        <div className="text-[12.5px] text-sub">Po krijohet përmbledhja…</div>
      ) : (
        <>
          <ul>
            {preview.map((b, i) => (
              <li
                key={i}
                className="flex gap-2.5 border-t border-black/10 py-2.5 text-[13.5px] leading-snug text-ink first:border-t-0"
              >
                <span className="font-bold text-ai">›</span>
                <span>{b}</span>
              </li>
            ))}
          </ul>
          {hasMore && (
            <button
              type="button"
              onClick={() => navigate("/permbledhja-e-dites")}
              className="mt-3.5 w-full rounded-pill bg-ai py-2.5 text-center font-head text-[13px] font-bold text-white transition hover:bg-brand-2"
            >
              Lexo përmbledhjen e plotë →
            </button>
          )}
        </>
      )}
    </div>
  );
}
